//=================================================
// Strobe text animation effect
//=================================================

import { getReducedMotion } from './user-preferences';
import { createInitializeOnce } from './utilities';

const initializeOnce = createInitializeOnce();

export default function setupStrobe() {
    document.querySelectorAll('.strobe').forEach((slider) => {
        if (!initializeOnce(slider)) return;

        // start animating when element enters viewport
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                // Only strobe if reduced motion is off and element is in viewport
                if (!getReducedMotion() && entry.isIntersecting) {
                    slider.classList.add('strobe__active');
                }
            });
        });

        observer.observe(slider);
    });
}
